export class AccountStatusFilters {
    '_in';
    'notIn';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "_in",
            "baseName": "in",
            "type": "Array<AccountState>",
            "format": ""
        },
        {
            "name": "notIn",
            "baseName": "notIn",
            "type": "Array<AccountState>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AccountStatusFilters.attributeTypeMap;
    }
    constructor() {
    }
}
